import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const links = [
    { label: "Features", to: "/features" },
    { label: "Pricing", to: "/pricing" },
    { label: "About", to: "/about" },
    { label: "FAQ", to: "/faq" },
    { label: "Contact", to: "/contact" },
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms", to: "/terms" },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main footer */}
      <div className="container mx-auto px-4 py-10 sm:py-12">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">

          {/* Brand + description */}
          <div className="max-w-xs">
            <div className="text-xl font-bold mb-2">🔒 ExamLock</div>
            <p className="text-gray-400 text-sm mb-3">
              AI-powered exam creation and real-time monitoring for Qatar and GCC schools.
              Private beta — limited school onboarding now open.
            </p>
            <a
              href="mailto:info@examlock.ai"
              className="text-blue-400 hover:text-blue-300 text-sm"
            >
              📧 info@examlock.ai
            </a>
            <p className="text-gray-500 text-xs mt-1">Mon–Fri, Doha time (AST)</p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide mb-3">Quick Links</h3>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-white text-sm transition duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Security bullets */}
          <div className="max-w-xs">
            <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide mb-3">Security &amp; Privacy</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>🔑 Role-based access control</li>
              <li>🛡️ Server-side enforcement</li>
              <li>📋 Timestamped audit logs</li>
              <li>☁️ Google Cloud / Firebase</li>
              <li>🔒 Student data never sold</li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-700">
        <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <span>© {currentYear} ExamLock. All rights reserved.</span>
          <span>Private beta · Qatar &amp; GCC first · Built using Google Cloud / Firebase</span>
        </div>
      </div>
    </footer>
  );
}
